export {};

declare global {
  interface Date {
    toLocalDateTimeFormat(locale?: string, options?: Intl.DateTimeFormatOptions): string;
  }
}

Date.prototype.toLocalDateTimeFormat = function (
  locale: string = 'en-US',
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }
): string {
  if (!this) return ''; // Handle null or undefined Date objects

  const timezoneOffset = this.getTimezoneOffset();
  const adjustedDate = new Date(this.getTime() - timezoneOffset * 60000);
  return new Intl.DateTimeFormat(locale, options).format(adjustedDate);
};
